module.exports = __webpack_public_path__ + "img/icon_weather_code.8eec091a.png";